import { App } from '@prisma/client'
import { AppUISettings } from './types'

export const getUISettings = (app: App): AppUISettings => {
  const settings: AppUISettings = (app?.uiSettings as any) ?? {}

  const isSocialMediaManager = app?.key === 'socialMediaManager'
  const isSales = app?.key === 'salesAssistant'
  const isExecutiveAssistant = app?.key === 'executiveAssistantV2'
  const isCustomerSupport = app?.key === 'customerSupport'
  const isBlogWriter = app?.key === 'contentCreator'

  return {
    chat: {
      isActive: settings.chat?.isActive ?? true,
      title: settings.chat?.title,
      placeholder: settings.chat?.placeholder,
      canSendMessage: settings.chat?.canSendMessage ?? true,
      canUploadAttachments: settings.chat?.canUploadAttachments ?? true,
      typeAttachments: settings.chat?.typeAttachments ?? [],
      messageSuggestions: settings.chat?.messageSuggestions ?? [],
    },
    form: {
      isActive: settings.form?.isActive ?? false,
    },
    sqlLite: {
      isActive: settings.sqlLite?.isActive ?? false,
      tabName: settings.sqlLite?.tabName ?? 'Tables',
    },
    task: {
      isActive: settings.task?.isActive ?? false,
      tabName: settings.task?.tabName ?? 'Tasks',
    },
    driveFile: {
      isActive: settings.driveFile?.isActive ?? false,
      tabName: settings.driveFile?.tabName ?? 'Files',
    },
    socialMediaPost: {
      isActive: isSocialMediaManager,
    },
    executiveAssistant: {
      isActive: isExecutiveAssistant,
    },
    salesLead: {
      isActive: isSales,
    },
    stickyNotes: {
      isActive: isExecutiveAssistant || isCustomerSupport,
    },
    knowledges: {
      isActive: isSocialMediaManager || isBlogWriter,
    },
    blogPost: {
      isActive: isBlogWriter,
    },
    templates: {
      isActive: isSales,
    },
  }
}

export const Helper = {
  getUISettings,
}
